<div class="starWrapper">
  <canvas #stars width="1920" height="979" style="width: 100%; height: 100%"></canvas>
</div>
<div class="position-relative h-100">
  <router-outlet></router-outlet>
</div>
